var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"cls-btn",class:{ rotate: _vm.rotate }},[_c('v-btn',{on:{"click":function($event){$event.stopPropagation();return _vm.$emit('click')}}},[_c('AppIcon',{attrs:{"name":"close"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }